/* 
  This is the scripting page for jfermi reactor.
  
  You can enter simple if-then statements or any complitated expressions.
  
  For example if you wish to start the feed pump from the 6th hours of the fermentation
  you can write:
  
    if (h>6) devices.feedPump.setMLH(5);
  
  and then after the 10th hour you would like to increase the feed pumping for you hungry microorganisms you may write  
  
    if (0<h && h<=6) devices.feedPump.setMLH(0);                // between 0 and 6
    if (6<h && h<=10) devices.feedPump.setMLH(5);               // 6..100
    if (10<h && h<=Infinity) devices.feedPump.setMLH(5);        // 10..forever
      
  There are some predefined variables that you may use in your script:
    h: elapsed time since the inoculation date in hours (1 means 1 hour, 1.5 means 1 hour and 30 minutes
       if the culture is not inoculated then the 'h' variable will be 0
    T: temperature in celsius
    pH: pH
    pO2: dissolved oxygen in percentage
    
  There are some predefined actions that you may use in your script:
    stop(): stop the currently running fermentation   
    log(value): log any value to the console, use it carefully only for testing purposes because it may spam your console

*/

logData("pH+1", pH+1);
logData("test", 100);

/*
if (STR==settings.Stirring_MAX_RPM && pO2<target_pO2) {
  settings.IQFlow_MAX_MLM = 500;
  settings.Stirring_MIN_RPM = 300;
}

if (GSFL==settings.IQFlow_MIN_MLM && pO2>target_pO2) {
  settings.IQFlow_MAX_MLM = 100;
  settings.Stirring_MIN_RPM = 100;
}
*/

//devices.parallaxPumpAcid.setMLH(Math.random() * 20);
//devices.parallaxPumpBase.setMLH((Math.random()>0.5) ? 15 : 0);
//devices.parallaxPumpFeed.setMLH((Math.random()>0.5) ? 15 : 0);

//devices.parallaxPumpAntifoam.setMLH(Math.random() * 20);

//devices.valve1.setValue(!devices.valve1.value);


/*
if (0<h && h<=1) devices.feedPump.setMLH(1);
if (1<h && h<=2) devices.feedPump.setMLH(20);
if (3<h && h<=4) devices.feedPump.setMLH(3);
if (5<h && h<=Infinity) devices.feedPump.setMLH(4);
*/